/**
 * Outcome flow — the value argument in three connected beats.
 * Capability language; plan matrix stays on /pricing.
 */

'use client'

import React from 'react'
import { LandingGlyph, type LandingGlyphKind } from './LandingGlyph'

const OUTCOMES: readonly {
  kind: LandingGlyphKind
  title: string
  text: string
}[] = [
  {
    kind: 'market',
    title: 'Markets beside your portfolio',
    text: 'Review prices alongside balances, positions, and P&L before deciding what to do next.',
  },
  {
    kind: 'connection',
    title: 'Connected account context',
    text: 'Keep supported account balances and activity in view. Available connections are shown in your desk.',
  },
  {
    kind: 'agent',
    title: 'Agents under your supervision',
    text: 'Review agent intent alongside your exposure, then use the desk controls to pause or stop activity.',
  },
] as const

export const BenefitsSection: React.FC = () => {
  return (
    <section
      id="workspace"
      className="lp-section lp-section-lattice"
      aria-labelledby="workspace-title"
    >
      <div className="lp-band lp-band-lattice">
        <header className="lp-band-head">
          <div className="lp-band-head-copy">
            <p className="lp-kicker">
              Why <span translate="no">Mechagora</span>
            </p>
            <h2 id="workspace-title" className="lp-section-title">
              Keep the whole desk in view.
            </h2>
            <p className="lp-section-lede">
              Prices move. Your context should not disappear when you check a position, review
              activity, or pause an agent.
            </p>
          </div>
        </header>

        <ol className="lp-briefing lp-briefing-trio" aria-label="How Mechagora keeps trading context together">
          {OUTCOMES.map((item) => (
            <li key={item.title} className="lp-briefing-row">
              <span className="lp-tile-icon" aria-hidden="true">
                <LandingGlyph kind={item.kind} />
              </span>
              <div className="lp-briefing-copy">
                <h3 className="lp-tile-title">{item.title}</h3>
                <p className="lp-tile-text">{item.text}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
